// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-card {
  display: flex;
  flex-direction: column;
}
.dashboard-card.hoverable:hover {
  transform: scale(1.01);
  transition-duration: 0.3s;
  transition-property: transform;
  border: solid 1px grey;
  cursor: pointer;
}
.dashboard-card .ant-card-body {
  padding: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.dashboard-card .ant-card-body .ant-card-meta {
  padding: 10px;
  background-color: #f0f8ff;
}
.dashboard-card .ant-card-body .dashboard-card-body {
  flex: 1;
}
`, "",{"version":3,"sources":["webpack://./src/Component/Dashboard/DashboardCard/DashboardCard.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF;AAEI;EACE,sBAAA;EACA,yBAAA;EACA,8BAAA;EACA,sBAAA;EACA,eAAA;AAAN;AAVA;EAeI,UAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;AAFJ;AAjBA;EAsBM,aAAA;EACA,yBAAA;AAFN;AArBA;EA2BM,OAAA;AAHN","sourcesContent":[".dashboard-card {\n  display: flex;\n  flex-direction: column;\n\n  &.hoverable {\n    &:hover {\n      transform: scale(1.01);\n      transition-duration: 0.3s;\n      transition-property: transform;\n      border: solid 1px grey;\n      cursor: pointer;\n    }\n  }\n\n  .ant-card-body {\n    padding: 0;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    overflow: auto;\n\n    .ant-card-meta {\n      padding: 10px;\n      background-color: #f0f8ff;\n    }\n\n    .dashboard-card-body {\n      flex: 1;\n    }\n\n  }\n\n}\n\n@drawer-width: 600px;@primary-color: #137CBD;@info-color: #137CBD;@success-color: #0F9960;@warning-color: #D9822B;@error-color: #DB3737;@link-color: #137CBD;@font-size-base: 14px;@heading-color: rgba(0, 0, 0, 0.85);@text-color: rgba(0, 0, 0, 0.65);@text-color-secondary: rgba(0, 0, 0, .45);@disabled-color: rgba(0, 0, 0, .25);@border-radius-base: 0px;@border-color-base: #d9d9d9;@box-shadow-base: 0 2px 8px rgba(0, 0, 0, 0.15);"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
